/**
 * Rôles utilisateur (cf. PRELLM_SPEC.md §4.6 + backend `domain/user.Role`).
 *
 * Les littéraux acceptés sont alignés EXACTEMENT avec le backend Go.
 * Sprint 8-B avait introduit par erreur un mapping 4-rôles fictif
 * (master/admin/member) qui rejetait les rôles backend réels — corrigé
 * en 8-C.
 *
 * Ordonné du plus privilégié au moins privilégié :
 *   - super_admin   : admin instance PreLLM (cross-tenant, staff Agenuity)
 *   - tenant_master : admin d'un tenant (CRUD users/keys/routes/providers)
 *   - tenant_user   : utilisateur consommant le tenant (ses propres requêtes)
 *
 * Toute valeur étrangère retournée par le backend = erreur de
 * désérialisation (cf. parseRole → AuthError('internal_error')).
 */
export type Role = 'super_admin' | 'tenant_master' | 'tenant_user'

export const ROLES: readonly Role[] = ['super_admin', 'tenant_master', 'tenant_user'] as const

/**
 * parseRole valide qu'une string serveur correspond à un rôle connu.
 * Retourne null si invalide (le caller décide : 401 hard fail, ou défaut).
 */
export function parseRole(raw: string | undefined | null): Role | null {
    if (!raw) {
        return null
    }
    return (ROLES as readonly string[]).includes(raw) ? (raw as Role) : null
}

/**
 * hasRoleAtLeast retourne true si `actual` est au moins équivalent à
 * `required` dans la hiérarchie ROLES (index plus petit = plus de droits).
 *
 * Utile pour les guards UI ("afficher le bouton seulement si master+").
 * NE remplace JAMAIS le contrôle backend : c'est une commodité d'affichage.
 */
export function hasRoleAtLeast(actual: Role, required: Role): boolean {
    return ROLES.indexOf(actual) <= ROLES.indexOf(required)
}
